module.exports = __webpack_public_path__ + "img/18.e4c7e102.jpg";